// extracted by mini-css-extract-plugin
export default {"WidgetContent":"GoogleMeetWidgetStudent_WidgetContent__PBLgO"};